export type {
  ValuePropCard,
  ValuePropImageType,
  ValuePropMedia,
  ValuePropTextSize,
  ValuePropsCardLayout,
  ValuePropsMobileLayout,
  ValuePropsSectionProps,
} from "./types";
export { default } from "./ValuePropsSection";
